module.exports = __webpack_public_path__ + "img/touxiang.ade4a230.jpg";